import {Schema} from '../types/Schema';
import {useEffect, useState} from 'react';
import {api, Data} from '../api';

export function useSchema(schemaId?: string, data?: Data): Schema | null {
  const [schema, setSchema] = useState<Schema | null>(null);

  useEffect(() => {
    if (schemaId) {
      (async () => {
        const ctx = api.newContext();
        const s = await api.fetchSchema(ctx, schemaId, data ?? {});
        setSchema(s);
      })();
    }
  }, [schemaId]);

  return schema;
}
